import { systemNotifications } from '~/utils/notifications'
import { clearState } from '~/utils/state'

export const state = () => ({
  notifications: [],
})

export const mutations = {
  CLEAR: clearState(state()),
}

export const getters = {
  unreadNotificationCount (state, getters) {
    return getters.notifications.filter(notification => notification.attributes.readAt === null).length
  },
  notifications (state, getters, rootState) {
    const notifications = []

    const client = rootState.auth.client
    const hasAuthProvider = client?.relationships?.authProviders?.data?.length > 0 || false

    if (client && !client.attributes.hasPassword && !hasAuthProvider) {
      notifications.push(systemNotifications.noPassword)
    }

    return notifications
  }
}
